const messages = {
	en: {
		header: "Session Expired",
		sessionExpired: "Your session has expired.",
		close: "CLOSE",
	},
};

export default messages;
